import {makeStyles} from '@material-ui/core';
import {Colors} from '../../styles/Colors';
import {ServiceFeature, ServiceFeatureName} from "../../store/types/ServiceFeature";

export const useStyles = makeStyles(() => ({
    mainDashboardContainer: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: Colors.White,
        overflow: 'hidden',
        position: 'relative',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 'calc(100% - 54px - 54px)',
        padding: '24px 96px',
    },
    rightSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    scrollable: {
        overflowY: 'auto',
        flex: 1,
        padding: '18px 90px 120px 80px',
        background: Colors.SmokeBackground,
    },
    contentContainer: {
        width: 1040,
        maxWidth: '100%',
    },
    sectionsContainer: {
        padding: '22px 16px 17px 16px',
        maxWidth: 970,
        display: 'flex',
        flexDirection: 'column',
    },
    sectionHeader: {
        fontSize: 16,
        fontWeight: 500,
        color: Colors.Text,
        marginTop: 32,

        '&:first-child': {
            marginTop: 0,
        },
    },
    rulesContainer: {
        margin: '24px 35px 10px 32px',
        '& label': {
            marginTop: 0,
        },
        '& div': {
            alignItems: 'center',
        },
    },
    ruleInput: {
        display: 'flex',
        paddingLeft: 0,
        alignItems: 'flex-start',
        gap: 8,
        marginBottom: '8px !important',
    },
    rowInsideContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    space: {
        marginLeft: '85px !important',
    },
    switchContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 32,
        marginLeft: -12,
    },
    switch: {
        marginTop: 0,
        marginBottom: 0,
        height: 'unset',
    },
    loaderWrapper: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40,
    },
}));
const noop = () => undefined;
export const blurNoop = () => noop;
export const findFeature = (
    features: ServiceFeature[] | undefined,
    name: ServiceFeatureName,
): ServiceFeature | undefined => features?.find((f) => f.name === name);
export const isOnDemandRecording = (feature?: ServiceFeature): boolean => {
    if (feature?.effective_flag_value !== 'Y') {
        return false;
    }
    const attr = feature?.attributes?.find((a) => a.name === 'on_demand');
    const eff = attr?.effective_values?.[0] ?? attr?.values?.[0];
    return eff === 'Y';
};